import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { createUri, Api } from '@api/utils';
import { Query } from './utils';
import { CutAPI } from '@api/cut';

import type { Cut } from '@/types/cuts';
import type { EmployeeCutMaterials } from '@/types/employees';

export const cutHooks = createApi({
    reducerPath: 'cutApi',
    baseQuery: fetchBaseQuery({
        baseUrl: createUri(Api.Cuts, '/cuts/V1'),
    }),
    endpoints: (build) => ({
        // todo: Migrate main CutActivity page to use RTK Query
        // todo: MO-1780
        cutActivity: build.query<
            Cut[],
            {
                token: string;
                pageNum: number;
                pageSize: number;
                startDate?: string;
                endDate?: string;
                employeeEmail?: string;
                locationIds?: string;
            }
        >({
            query: ({ token, ...params }) => ({
                url: CutAPI.Activity,
                headers: { Authorization: `Bearer ${token}` },
                params,
            }),
        }),
        employeeCutMaterials: build.query<
            EmployeeCutMaterials,
            { token: string; LocationID: number; EmployeeEmail: string; startDate?: string; endDate?: string }
        >({
            query: ({ token, ...params }) => ({
                url: CutAPI.MaterialsByEmployee,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params,
            }),
        }),
    }),
});

/** Intermediary Wrapper */
const cut = {
    useCutActivityQuery: Query.withToken(cutHooks.useCutActivityQuery),
    useEmployeeCutMaterialsQuery: Query.withToken(cutHooks.useEmployeeCutMaterialsQuery),
};

export const { useCutActivityQuery, useEmployeeCutMaterialsQuery } = cut;
